/* Web blanca: solo presentación. El carrito, el regalo, el Protocol y la
   preventa siguen en cart-controller.js; acá no se agrega nada al carrito. */
(function () {
  "use strict";

  // Tarjeta: cantidad −/+ (la lee [data-quick-add] vía data-quantity).
  document.addEventListener("click", (event) => {
    const step = event.target.closest("[data-cb-qty-step]");
    if (!step) return;
    event.preventDefault();
    const card = step.closest("[data-cb-card]");
    const value = card?.querySelector("[data-cb-qty-value]");
    const add = card?.querySelector("[data-quick-add]");
    if (!value || !add) return;
    const max = Number.parseInt(card.querySelector("[data-cb-max]")?.dataset.cbMax, 10) || 99;
    const next = Math.min(max, Math.max(1, (Number.parseInt(value.textContent, 10) || 1) + Number(step.dataset.cbQtyStep)));
    value.textContent = String(next);
    add.dataset.quantity = String(next);
  });

  // Tarjeta: puntos de foto 1 / foto 2 según el deslizamiento.
  const syncDots = (track) => {
    const media = track.closest("[data-cb-media]");
    const i = track.scrollLeft > track.clientWidth / 2 ? 1 : 0;
    media?.querySelectorAll("[data-cb-dot]").forEach((d) => d.classList.toggle("is-on", Number(d.dataset.cbDot) === i));
  };
  document.addEventListener("scroll", (event) => {
    const track = event.target;
    if (track instanceof HTMLElement && track.matches("[data-cb-track]")) syncDots(track);
  }, { capture: true, passive: true });

  // Computador: al pasar el mouse los puntos también cambian.
  document.addEventListener("mouseover", (event) => {
    const media = event.target.closest?.(".cb-media--2");
    if (!media || media.dataset.cbHover) return;
    media.dataset.cbHover = "1";
    const set = (i) => media.querySelectorAll("[data-cb-dot]").forEach((d) => d.classList.toggle("is-on", Number(d.dataset.cbDot) === i));
    media.addEventListener("mouseenter", () => set(1));
    media.addEventListener("mouseleave", () => set(0));
    set(1);
  });
})();
